import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types: FilteredTypes, Creators: FilteredActions } = createActions(
  {
    startListeningQueryUpdate: ['threshold'],
    stopListeningQueryUpdate: [],
    fetchFilteredExperiences: [],
    setFilteredExperiences: ['experiences'],
  },
  { prefix: 'FILTERED_' }
);

export const INITIAL_STATE = Immutable({
  isFetching: true,
  isListenerActive: false,
  filteredExperiences: [],
});

const setFilteredExperiencesHandler = (state, { experiences }) =>
  state.set('filteredExperiences', Immutable(experiences)).set('isFetching', false);

const fetchFilteredExperiencesHandler = state => state.set('isFetching', true);

const startListeningQueryUpdate = state => state.set('isListenerActive', true);
const stopListeningQueryUpdate = state => state.set('isListenerActive', false);

export const reducer = createReducer(INITIAL_STATE, {
  [FilteredTypes.FETCH_FILTERED_EXPERIENCES]: fetchFilteredExperiencesHandler,
  [FilteredTypes.SET_FILTERED_EXPERIENCES]: setFilteredExperiencesHandler,
  [FilteredTypes.START_LISTENING_QUERY_UPDATE]: startListeningQueryUpdate,
  [FilteredTypes.STOP_LISTENING_QUERY_UPDATE]: stopListeningQueryUpdate,
});
